// src/components/features/CustomerDeviceSelector.js
// Müşteri ve Cihaz seçim bileşeni - Servis kaydı ve diğer formlar tarafından kullanılabilir

import React from 'react';
import {
    Grid, TextField, Autocomplete, Button, createFilterOptions
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AddIcon from '@mui/icons-material/Add';

const CustomerDeviceSelector = ({
    customers,
    devices,
    selectedCustomerId,
    selectedDeviceId,
    teslimTarihi,
    setSelectedCustomerId,
    setSelectedDeviceId,
    setTeslimTarihi,
    onAddCustomer
}) => {
    return (
        <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} md={5}>
                <Autocomplete
                    options={customers}
                    getOptionLabel={(option) => option.adSoyad || ''}
                    value={customers.find(c => c.id === selectedCustomerId) || null}
                    onChange={(event, newValue) => {
                        setSelectedCustomerId(newValue ? newValue.id : '');
                    }}
                    filterOptions={(options, params) => {
                        const filtered = createFilterOptions({
                            stringify: (option) => option.adSoyad,
                            ignoreCase: true,
                            matchFrom: 'any',
                            trim: true
                        })(options, params);

                        return filtered.sort((a, b) => {
                            const input = params.inputValue.toLowerCase();
                            const aLabel = (a.adSoyad || '').toLowerCase();
                            const bLabel = (b.adSoyad || '').toLowerCase();

                            if (aLabel === input && bLabel !== input) return -1;
                            if (bLabel === input && aLabel !== input) return 1;

                            const aStarts = aLabel.startsWith(input);
                            const bStarts = bLabel.startsWith(input);
                            if (aStarts && !bStarts) return -1;
                            if (!aStarts && bStarts) return 1;

                            return aLabel.localeCompare(bLabel);
                        });
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Müşteri Seçin"
                            placeholder="İsim ile arayın..."
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                        {onAddCustomer && (
                                            <Button
                                                size="small"
                                                variant="text"
                                                startIcon={<AddIcon />}
                                                onClick={(e) => { e.stopPropagation(); onAddCustomer(); }}
                                                sx={{ minWidth: 'auto', p: 0.5, ml: 1 }}
                                            >
                                                Yeni
                                            </Button>
                                        )}
                                    </>
                                )
                            }}
                        />
                    )}
                    noOptionsText="Müşteri bulunamadı"
                />
            </Grid>
            <Grid item xs={12} md={5}>
                <Autocomplete
                    options={
                        selectedCustomerId
                            ? devices.filter(d => d.musteriId === selectedCustomerId)
                            : devices
                    }
                    getOptionLabel={(option) => `${option.seriNumarasi} - ${option.marka} ${option.model}`}
                    value={devices.find(d => d.id === selectedDeviceId) || null}
                    onChange={(event, newValue) => setSelectedDeviceId(newValue ? newValue.id : '')}
                    filterOptions={(options, params) => {
                        const input = params.inputValue.toLowerCase();
                        const filtered = options.filter(option => {
                            const label = `${option.seriNumarasi} ${option.marka} ${option.model}`.toLowerCase();
                            return label.includes(input);
                        });

                        return filtered.sort((a, b) => {
                            const getLabel = (opt) => `${opt.seriNumarasi} ${opt.marka} ${opt.model}`.toLowerCase();
                            const aLabel = getLabel(a);
                            const bLabel = getLabel(b);
                            const aStarts = aLabel.startsWith(input);
                            const bStarts = bLabel.startsWith(input);
                            if (aStarts && !bStarts) return -1;
                            if (!aStarts && bStarts) return 1;
                            return aLabel.localeCompare(bLabel);
                        });
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Cihaz Seçin veya Taratın"
                            placeholder={selectedCustomerId ? "Müşterinin cihazlarında ara..." : "Seri No ile tüm cihazlarda ara..."}
                            helperText={!selectedCustomerId && "Cihaz seçince müşteri otomatik gelir."}
                        />
                    )}
                    noOptionsText="Cihaz bulunamadı"
                />
            </Grid>
            <Grid item xs={12} md={2}>
                <DatePicker
                    label="Teslim Tarihi *"
                    value={teslimTarihi}
                    onChange={setTeslimTarihi}
                    slotProps={{ textField: { fullWidth: true } }}
                    format="dd/MM/yyyy"
                />
            </Grid>
        </Grid>
    );
};

export default CustomerDeviceSelector;
